window.addEventListener('load', function() {

    // apply the filter changes selected by the user by reloading the page with the new filter criteria
    // (the filter pane is only rendered when at least one filter is shown, so it may be absent)
    const filterForm = document.getElementById('frm-participant-filter');
    if (filterForm) {
        const filterElements = filterForm.getElementsByTagName('select');
        for (const filterElement of filterElements) {
            filterElement.addEventListener('change', applyFilter);
        }
    }

    function applyFilter(e) {

        let currentLocation = new URL(window.location.href);
        let currentSearchParams = currentLocation.searchParams;

        const filterElements = selfAndSiblings(e.target)
        for (const filterElement of filterElements) {
            currentSearchParams.delete(filterElement.name);
            if (filterElement.value !== null && filterElement.value !== '') {
                currentSearchParams.append(filterElement.name, filterElement.value)
            }
        }

        window.location.href = currentLocation.href

    }

    // see https://www.javascripttutorial.net/javascript-dom/javascript-siblings/
    function selfAndSiblings(element) {

        let siblings = [];

        let sibling = element.parentNode.firstChild;
        while (sibling) {
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }

        return siblings;

    }

});

